const CONSTANTS = {
   PANDING: 'P',
   ACTIVE: "A",
   DEACTIVE: 'D',

};

export default CONSTANTS;
